// extracted by mini-css-extract-plugin
export default {"continue":"Al-z"};